import { Map } from "immutable"
import * as React from "react"
import 'intersection-observer';
import { PublicSite_CustomPageData } from "../../../application.mod";
import { InView } from 'react-intersection-observer';
import { Action, AsyncState, IOWidget, mk_widget, Pair } from "widgets-for-react"
import { ImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen"
import { CMSState, Link, Id, ImageSize } from "../../../../cms/blocks/types.gen"
import { link, getClassName } from "../../../../cms/blocks/utils.gen"
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod";
import { ExtraImages } from "../../../utils/extra_images.mod";
import { PublicSiteState } from "../../../../../public_site.main.mod";
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types";
import { FeaturedContentBlock } from "./featuredContent";

export type ButtonProps<customBlockData, extra_images> = (
  | { kind: "button"; on_click: () => Action<CMSState<customBlockData, extra_images, never>> }
  | Link ) & { title: string }

export type textImageBlockProps<customBlockData, extra_images> = {
  blockIndex: number
  imageLocation: "left" | "right"
  field_image?: ParsedMediaImage
  image?: Id
  image_alt?: string
  label?: string
  title: string
  introduction?: string
  text: string
  primary_button?: Link
  secondary_button?: ButtonProps<customBlockData, extra_images>
  backgroundImage: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
  get_default_data_src:(() => ImageSize<ExtraImages>)
  get_default_data_srcset:(() => Pair<ImageSize<ExtraImages>, string>[])
}

export type textImageBlockStyle = Partial<{
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  visual_classname: string
  image_classname: string
  clickable_wrapper_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function textImageBlock<customBlockData>(
  props: textImageBlockProps<customBlockData, ExtraImages>,
  options?: { style?: textImageBlockStyle; key?: string }
): (s:CMSState<customBlockData, ExtraImages, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData,ExtraImages, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData,ExtraImages, PublicSite_CustomPageData>) => (public_state:PublicSiteState) =>
    mk_widget({
      run: setState => {
        return (
          <>
          <InView
            as="section"
            onChange={(inView) => blockInviewHandler('featuredContent', inView, `io-${options && options.key ? options.key : props.blockIndex}`, getClassName(options, "inview_classname", "inview"))}
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.blockIndex}`}
            className=""
            key={options && options.key ? options.key : `block-${props.blockIndex}`}
          >

            <FeaturedContentBlock
              isStyleguide={false}
              alignImage={props.imageLocation}
              backgroundImage={props.backgroundImage}
              label={props.label}
              title={props.title}
              intro={props.introduction}
              field_image={props.field_image}
              primaryButton={props.primary_button}
              image={props.image}
              image_alt={props.image_alt}
            />

          </InView>
        </>
        )
      },
    })
}
